
/* =======================================================================
   NURIFICATION — coming soon
   1. SOCIAL / CONTACT LINKS — fill these in and everything wires itself up
   ======================================================================= */
var LINKS = {
  instagram : 'https://www.instagram.com/nurificationuk',
  tiktok    : 'https://www.tiktok.com/@nurificationuk',
  facebook  : 'https://www.facebook.com/share/1DES7nq3Rg/',
  whatsapp  : 'https://wa.me/Nurificationuk',
  phone     : '03334447867',
  email     : 'Enquiries@nurification.com'
};

(function () {
  'use strict';

  /* ---- wire the social / contact icons ---- */
  var href = {
    instagram: function (v) { return v; },
    facebook:  function (v) { return v; },
    tiktok:    function (v) { return v; },
    whatsapp:  function (v) { return /^https?:/.test(v) ? v : 'https://wa.me/' + v.replace(/[^0-9]/g, ''); },
    phone:     function (v) { v = v.replace(/[^0-9+]/g, ''); return 'tel:' + (v.charAt(0) === '0' ? '+44' + v.slice(1) : v); },
    email:     function (v) { return 'mailto:' + v; }
  };
  document.querySelectorAll('[data-social]').forEach(function (a) {
    var key = a.getAttribute('data-social'), val = (LINKS[key] || '').trim();
    if (!val) { a.setAttribute('aria-disabled', 'true'); a.classList.add('off'); return; }
    a.href = href[key](val);
    if (key !== 'phone' && key !== 'email') { a.target = '_blank'; a.rel = 'noopener'; }
  });

  document.getElementById('yr').textContent = new Date().getFullYear();

  /* each travelling beam needs the length of the outline it runs along */
  document.querySelectorAll('.beam').forEach(function (g) {
    var path = g.querySelector('.bm-c');
    if (path && path.getTotalLength) { g.style.setProperty('--plen', path.getTotalLength().toFixed(0) + 'px'); }
  });

  /* ---- day / night ---- */
  /* a light-touch mode for phones and low-core devices, so motion stays fluid */
  (function () {
    var small = matchMedia('(max-width: 820px)').matches;
    var cores = navigator.hardwareConcurrency || 8;
    var slow = navigator.connection && /2g/.test(navigator.connection.effectiveType || '');
    if (small || cores <= 4 || slow) { document.body.classList.add('lite'); }
  }());

  var themeBtn = document.getElementById('themeToggle');
  var noMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function applyTheme(mode) {
    var day = mode === 'day';
    document.body.classList.toggle('day', day);
    themeBtn.querySelector('.lbl').textContent = day ? 'Night' : 'Day';
    themeBtn.setAttribute('aria-pressed', String(day));
    try { localStorage.setItem('nurTheme', mode); } catch (err) {}
  }
  var veil = document.getElementById('themeVeil'), switching = false;
  function setTheme(mode, animate) {
    if (!animate || noMotion || !veil.animate) { applyTheme(mode); return; }
    if (switching) { return; }
    switching = true;
    // fade up to the new mode's own ground colour, change underneath it, fade back:
    // a true dissolve between the two palettes on every browser
    veil.style.background = mode === 'day' ? '#f5f0e6' : '#0a0907';
    veil.animate([{ opacity: 0 }, { opacity: 1 }],
      { duration: 420, easing: 'cubic-bezier(.4,0,.6,1)', fill: 'forwards' }).onfinish = function () {
        document.body.classList.add('swapping');
        applyTheme(mode);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { document.body.classList.remove('swapping'); });
          veil.animate([{ opacity: 1 }, { opacity: 0 }],
            { duration: 560, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards' }).onfinish = function () {
              switching = false;
            };
        });
      };
  }
  themeBtn.addEventListener('click', function () {
    setTheme(document.body.classList.contains('day') ? 'night' : 'day', true);
  });
  setTheme((function () {
    var q = location.search.match(/[?&]theme=(day|night)/);
    if (q) { return q[1]; }
    try { return localStorage.getItem('nurTheme') || 'night'; } catch (err) { return 'night'; }
  }()));

  /* ---- store owner's password entry ---- */
  var pwToggle = document.getElementById('pwToggle'), pwForm = document.getElementById('pwForm');
  if (pwToggle && pwForm) {
    pwToggle.addEventListener('click', function () {
      pwForm.hidden = false; pwToggle.hidden = true;
      pwForm.querySelector('input').focus();
    });
    if (pwForm.querySelector('.pw-err')) { pwForm.hidden = false; pwToggle.hidden = true; }
  }

  /* =====================================================================
     2. INTRO — نور is written, the moon sweeps in, it shines, the wordmark
        types in, then the whole lockup settles into the page (~3s)
     ===================================================================== */
  var intro = document.getElementById('intro'), body = document.body;
  var MORPH_AT = 5050, MORPH_MS = 820;   // draw 0.12-1.73s · moon 1.78-2.79s · lock flash 2.70s · wordmark 2.88-3.64s · big shine 3.68-4.50s · hold · settle
  var timers = [], done = false;

  var skipIntro = matchMedia('(prefers-reduced-motion: reduce)').matches ||
                  /[?&]nointro/.test(location.search) || window.NUR_NOINTRO;   // plays on every load

  if (!intro || skipIntro) { finish(); }
  else { play(); }

  function play() {
    body.classList.add('intro-on');
    // dash lengths for the calligraphy pens
    intro.querySelectorAll('.pen').forEach(function (p) {
      p.style.setProperty('--len', p.getTotalLength().toFixed(1));
    });
    // the moon pieces start just beyond the screen edge on any device, so the
    // journey in is always the same graceful length
    var im = intro.querySelector('.intro-mark'), r = im.getBoundingClientRect();
    var scale = r.height / 1455.03;                       // screen px per logo unit
    if (scale > 0) {
      // each piece starts right at the edge of the screen — a sliver already visible —
      // so the eye follows it all the way in from the top / bottom of the page
      var vh = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
      im.style.setProperty('--fly', Math.round((vh / 2 + r.height * 0.22) / scale) + 'px');
    }
    requestAnimationFrame(function () { intro.classList.add('play'); });
    timers.push(setTimeout(function () { body.classList.add('page-in'); }, MORPH_AT - 260));
    timers.push(setTimeout(morph, MORPH_AT));
    intro.addEventListener('click', jump);
    window.addEventListener('keydown', jump);
    window.addEventListener('touchstart', jump, { passive: true });
  }

  function jump() { if (!done) { timers.forEach(clearTimeout); timers = []; body.classList.add('page-in'); morph(); } }

  function morph() {
    var a = intro.querySelector('.intro-mark').getBoundingClientRect();
    var b = document.querySelector('.logo').getBoundingClientRect();
    var stack = document.getElementById('introStack'), r = stack.getBoundingClientRect();
    var s = b.width / a.width;
    var tx = (b.left + b.width / 2) - (a.left + a.width / 2);
    var ty = (b.top + b.height / 2) - (a.top + a.height / 2);
    stack.style.transformOrigin = (a.left + a.width / 2 - r.left) + 'px ' + (a.top + a.height / 2 - r.top) + 'px';
    // one continuous movement: the lockup glides to its place on the page while the
    // page itself is already fading up behind it
    anim(stack, [{ transform: 'none' }, { transform: 'translate(' + tx + 'px,' + ty + 'px) scale(' + s + ')' }],
         { duration: MORPH_MS, easing: 'cubic-bezier(.33,0,.24,1)', fill: 'forwards' });
    anim(intro.querySelector('.intro-bg'), [{ opacity: 1 }, { opacity: 0 }],
         { duration: Math.round(MORPH_MS * 0.7), easing: 'linear', fill: 'forwards' });
    timers.push(setTimeout(finish, MORPH_MS + 30));
  }

  function anim(el, frames, opts) { if (el && el.animate) { el.animate(frames, opts); } }

  function finish() {
    if (done) { return; }
    done = true;
    body.classList.remove('intro-on');
    body.classList.add('intro-done');
    setTimeout(function () { body.classList.add('revealed'); }, 1600);
    startShine();
    startStars();
    smoothnessGuard();
    if (intro && intro.parentNode) { intro.parentNode.removeChild(intro); }
    window.removeEventListener('keydown', jump);
  }

  /* ---------- performance ----------------------------------------------------
     The page shine and the reveal are the only things that were still driving the
     main thread once the page had settled. The bands are parked off the artwork for
     ~60% of every 7s cycle, so we switch each one on only while it is actually
     travelling; and the reveal animations are `fill:both`, so they stay applied
     forever and keep the big frame SVG on the animated path -- once they have
     played we drop them. Neither changes a single pixel. */
  function pulse(sel, delay, motion) {
    var el = document.querySelector(sel);
    if (!el) { return; }
    function run() {
      el.classList.add('run');
      setTimeout(function () { el.classList.remove('run'); }, delay + motion + 120);
    }
    run();
    setInterval(run, 7000);
  }
  /* Each star flares for 40% of its cycle and is invisible for the other 60%.
     Run the flare only for that window: same rhythm, same look, no idle repaints. */
  function startStars() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches) { return; }
    document.querySelectorAll('.stars i').forEach(function (star) {
      var b = star.querySelector('b');
      if (!b) { return; }
      var cs = getComputedStyle(star);
      var d  = parseFloat(cs.getPropertyValue('--d')) * 1000;
      var dl = parseFloat(cs.getPropertyValue('--dl')) * 1000;
      if (!(d > 0)) { return; }
      var flare = d * 0.4;
      b.addEventListener('animationend', function () { b.classList.remove('flare'); });
      function go(offset) {
        if (b.classList.contains('flare')) { return; }   // still flaring; skip this tick
        b.style.animationDelay = offset ? (-offset) + 'ms' : '';
        b.classList.add('flare');
      }
      // honour the original negative delay so the sky keeps its staggered rhythm
      var phase = ((-dl % d) + d) % d;
      if (phase < flare) {
        go(phase);
        setTimeout(function () { go(0); setInterval(function () { go(0); }, d); }, d - phase);
      } else {
        setTimeout(function () { go(0); setInterval(function () { go(0); }, d); }, d - phase);
      }
    });
  }


  /* ---- adaptive smoothness guard -------------------------------------------
     Older phones and tablets cannot composite the heavier layers without
     dropping frames, which is seen as the screen blinking. Rather than guess a
     device class, measure the page as it actually runs on the device and peel
     off the most expensive layer until it holds a steady frame rate. A capable
     device never steps down and looks exactly as designed. */
  function smoothnessGuard() {
    var forced = location.search.match(/[?&]perf=(off|[123])/);
    if (forced) {
      if (forced[1] === 'off') { return; }
      for (var f = 1; f <= +forced[1]; f++) { body.classList.add('perf-' + f); }
      return;
    }
    if (noMotion) { return; }
    var tier = 0;
    /* Touch devices (phones and tablets) go straight to the light rendering.
       The client confirmed this level is completely steady on their old hardware,
       and a blink caused by the GPU running out of texture memory does not always
       show up as a dropped frame, so measuring first is not safe enough there.
       ?perf=auto opts a touch device back into the measure-then-step behaviour. */
    var touch = false;
    try {
      touch = matchMedia('(pointer:coarse)').matches || matchMedia('(max-width:1024px)').matches;
    } catch (err) {}
    if (touch && !/[?&]perf=auto/.test(location.search)) {
      body.classList.add('perf-1');
      return;
    }
    /* a desktop with very few cores is weak enough to start one step down */
    if ((navigator.hardwareConcurrency || 8) <= 4) { tier = 1; body.classList.add('perf-1'); }

    function sample() {
      var dts = [], last = performance.now(), n = 0;
      function step(now) {
        var dt = now - last; last = now;
        if (document.hidden) { setTimeout(sample, 1500); return; }
        if (n++ > 4) { dts.push(dt); }
        if (dts.length < 140) { requestAnimationFrame(step); return; }
        judge(dts);
      }
      requestAnimationFrame(step);
    }
    function judge(dts) {
      var s = dts.slice().sort(function (a, b) { return a - b; });
      var med = s[s.length >> 1], late = 0;
      for (var i = 0; i < dts.length; i++) { if (dts[i] > med * 1.8) { late++; } }
      var stuttering = late / dts.length > 0.1;   // frames being dropped
      var slow = med > 20;                        // or simply never reaching ~50fps
      if ((stuttering || slow) && tier < 3) {
        tier++;
        body.classList.add('perf-' + tier);
        setTimeout(sample, 900);
      }
    }
    setTimeout(sample, 1500);
  }

  function startShine() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches) { return; }
    pulse('.pg-sweep', 200, 2660);
    pulse('.pg-sweep-w', 750, 2660);
    pulse('.metal', 1300, 2660);
  }

  var m = location.search.match(/[?&]t=([\d.]+)/);
  if (m) {
    var T = +m[1] * 1000;
    timers.forEach(clearTimeout);
    setTimeout(function () {
      document.querySelectorAll('svg').forEach(function (sv) { if (sv.pauseAnimations) { sv.pauseAnimations(); sv.setCurrentTime(T / 1000); } });
      document.getAnimations().forEach(function (an) { an.pause(); try { an.currentTime = T; } catch (e) {} });
    }, 60);
  }
  if (/[?&]still/.test(location.search)) {
    body.classList.add('still');
    document.querySelectorAll('svg').forEach(function (sv) { if (sv.pauseAnimations) { sv.pauseAnimations(); } });
  }
}());

/* =====================================================================
   SHIMMER WAVE — ONLY AROUND THE DOME
   The wave used to run on one layer as big as the page, masked so it only
   SHOWED outside the dome — but the GPU still had to rebuild that whole
   masked page-sized surface every frame. Now it only exists where it can be
   seen: one box for the band above the dome's shoulders (both corners
   included) and one for each strip beside the dome's walls, down to where
   the pattern fades out. Each box keeps the original three masks (dome
   cut-out, tiny-Nur tiles, fade), positioned as if it were still the full
   page, and its canvas is drawn in page coordinates — so all the pieces form
   one continuous wave, exactly the one that was there before.
   ===================================================================== */
(function () {
  var wall = document.querySelector('.wall'), host = document.querySelector('.shimmer'),
      stage = document.getElementById('stage');
  if (!wall || !host || !stage) { return; }
  var probe = document.createElement('canvas');
  if (!(probe.getContext && probe.getContext('2d'))) { return; }
  if (document.body.classList.contains('dome-full')) { return; }     // ?dome=off keeps the old layer

  var SIN = Math.sin(55 * Math.PI / 180), COS = Math.cos(55 * Math.PI / 180);
  var PAL = { night: ['255,244,222', '.40', '255,250,236', '.95'],
              day:   ['176,138,72',  '.42', '150,112,48',  '.78'] };
  var STOPS = [0, .355, .465, .50, .535, .645, 1];
  var boxes = [], built = '', drawnDay = null;

  function geom() {
    var desk = getComputedStyle(document.querySelector('.frame--d')).display !== 'none';
    var u = stage.offsetWidth / (desk ? 1600 : 941);
    var W = wall.clientWidth, H = wall.clientHeight;
    var sr = stage.getBoundingClientRect(), wr = wall.getBoundingClientRect();
    var sx = sr.left - wr.left, sy = sr.top - wr.top;
    /* the arch's outer walls (stage units) and the height where they turn into the dome */
    var A = desk ? { l: 44.4, r: 1555.6, s: 392.1 } : { l: 26.0, r: 915.0, s: 505.0 };
    var fadeEnd = H * 0.8;                                  // the pattern is fully transparent below this
    var yS = Math.min(fadeEnd, sy + A.s * u);
    var xL = sx + A.l * u, xR = sx + A.r * u;
    var R = [{ x: 0, y: 0, w: W, h: yS }];
    if (fadeEnd > yS) {
      if (xL > 0) { R.push({ x: 0, y: yS, w: xL, h: fadeEnd - yS }); }
      if (xR < W) { R.push({ x: xR, y: yS, w: W - xR, h: fadeEnd - yS }); }
    }
    return { u: u, W: W, H: H, desk: desk, R: R, p: 876 * u };
  }

  function masks(g, r) {
    var Dw = (g.desk ? 4800 : 2823) * g.u, Dh = (g.desk ? 3780 : 5016) * g.u;
    var Tw = 90 * g.u, Th = 126 * g.u;
    var size = Dw + 'px ' + Dh + 'px,' + Tw + 'px ' + Th + 'px,' + g.W + 'px ' + g.H + 'px';
    var pos = ((g.W - Dw) / 2 - r.x) + 'px ' + ((g.H - Dh) / 2 - r.y) + 'px,' +
              ((g.W - Tw) / 2 - r.x) + 'px ' + (-r.y) + 'px,' +
              (-r.x) + 'px ' + (-r.y) + 'px';
    return '-webkit-mask-size:' + size + ';mask-size:' + size +
           ';-webkit-mask-position:' + pos + ';mask-position:' + pos + ';';
  }

  function paint(b, g) {
    var cv = b.cv, ctx = cv.getContext('2d'), p = g.p;
    var w = cv.offsetWidth, h = cv.offsetHeight;
    if (!w || !h) { return; }
    var s = 1;                                  // a soft band needs no more than CSS-pixel detail
    cv.width = Math.round(w * s); cv.height = Math.round(h * s);
    ctx.setTransform(cv.width / w, 0, 0, cv.height / h, 0, 0);
    var day = document.body.classList.contains('day');
    var pal = day ? PAL.day : PAL.night;
    var clear = 'rgba(' + pal[0] + ',0)', soft = 'rgba(' + pal[0] + ',' + pal[1] + ')',
        core = 'rgba(' + pal[2] + ',' + pal[3] + ')';
    var col = [clear, clear, soft, core, soft, clear, clear];
    /* phase of the original page-sized box: CSS starts its gradient line at
       centre - (L/2)u, u = (sin, -cos), for a box (W + .83p) x (H + .58p) sitting at (0, -.58p) */
    var Wb = g.W + .83 * p, Hb = g.H + .58 * p, Lb = Wb * SIN + Hb * COS;
    var tSg = (Wb / 2) * SIN - (Hb / 2) * COS - Lb / 2;
    /* this canvas sits at (r.x, r.y - .58p) in the page, i.e. (r.x, r.y) inside that box */
    var tS = tSg - (b.r.x * SIN - b.r.y * COS);
    var c0 = Math.min(0, w * SIN, -h * COS, w * SIN - h * COS),
        c1 = Math.max(0, w * SIN, -h * COS, w * SIN - h * COS);
    var tA = c0 - p, tB = c1 + p, span = tB - tA;
    var gr = ctx.createLinearGradient(tA * SIN, -tA * COS, tB * SIN, -tB * COS);
    for (var k = Math.floor((tA - tS) / p) - 1; tS + k * p <= tB; k++) {
      for (var i = 0; i < STOPS.length; i++) {
        var pos = (tS + (k + STOPS[i]) * p - tA) / span;
        if (pos >= 0 && pos <= 1) { gr.addColorStop(pos, col[i]); }
      }
    }
    ctx.clearRect(0, 0, w, h);
    ctx.fillStyle = gr;
    ctx.fillRect(0, 0, w, h);
  }

  function build() {
    var g = geom();
    var key = [g.W, g.H, g.u.toFixed(5), g.desk].join(',');
    if (key === built) { return; }
    built = key;
    boxes.forEach(function (b) { b.el.parentNode && b.el.parentNode.removeChild(b.el); });
    boxes = [];
    var frag = document.createDocumentFragment();
    g.R.forEach(function (r) {
      var el = document.createElement('div');
      el.className = 'sh-r';
      el.setAttribute('aria-hidden', 'true');
      el.style.cssText = 'left:' + r.x + 'px;top:' + r.y + 'px;width:' + r.w + 'px;height:' + r.h + 'px;' + masks(g, r);
      var cv = document.createElement('canvas');
      cv.className = 'sh-c';
      el.appendChild(cv);
      frag.appendChild(el);
      boxes.push({ el: el, cv: cv, r: r });
    });
    wall.insertBefore(frag, host);           // same place in the stacking order as the old layer
    host.classList.add('sh-off');
    boxes.forEach(function (b) { paint(b, g); });   // one batch: every box starts its wave on the same frame
    drawnDay = document.body.classList.contains('day');
    build.g = g;
  }

  build();
  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(build, 150); });
  if (window.MutationObserver) {
    new MutationObserver(function () {
      var day = document.body.classList.contains('day');
      if (day !== drawnDay && build.g) { drawnDay = day; boxes.forEach(function (b) { paint(b, build.g); }); }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }
}());


/* =====================================================================
   DIAGNOSTIC MODE — off unless the URL asks for it, so real visitors
   never load or run any of this.
     ?test=nobg      tiny-Nur background removed entirely
     ?test=nobganim  pattern stays, its shimmer animation stops
     ?test=nostars   ?test=nobeams   ?test=nosilk   ?test=noglow
     ?test=nofilters ?test=noshine   ?test=static (all motion off)
     ?diag=1         on-screen FPS meter + live on/off switches
   ===================================================================== */
(function () {
  var q = location.search;
  var want = (q.match(/[?&]test=([a-z]+)/) || [])[1];
  var diag = /[?&]diag=1/.test(q);
  if (!want && !diag) { return; }

  var RULES = {
    nobg:      '.shimmer,.wall::before{display:none!important}',
    nobganim:  '.shimmer i{animation:none!important}',
    nostars:   '.stars{display:none!important}',
    nobeams:   '.beam{display:none!important}',
    nosilk:    '.silk{display:none!important}',
    noglow:    '.neon{display:none!important}',
    noshine:   '.pg-sweep,.pg-sweep-w{display:none!important}.metal{animation:none!important}',
    static:    '*,*::before,*::after{animation:none!important;transition:none!important}'
  };
  var LABEL = {
    nobg: 'Tiny-Nur background', nobganim: 'Background shimmer motion', nostars: 'Twinkling stars',
    nobeams: 'Gold dome beams', nosilk: 'Silk texture', noglow: 'Dome glow (blur)',
    noshine: 'Logo / text shine', static: 'ALL animation'
  };
  var sheets = {};
  function setOff(key, off) {
    if (off && !sheets[key]) {
      var s = document.createElement('style');
      s.textContent = RULES[key];
      document.head.appendChild(s);
      sheets[key] = s;
    } else if (!off && sheets[key]) {
      sheets[key].remove();
      delete sheets[key];
    }
  }
  if (want && RULES[want]) { setOff(want, true); }
  if (!diag) { return; }

  /* ---- on-screen meter: frames per second and how many frames ran long ---- */
  var box = document.createElement('div');
  box.setAttribute('style',
    'position:fixed;left:8px;top:8px;z-index:9999;background:rgba(0,0,0,.86);color:#fff;' +
    'font:12px/1.45 -apple-system,system-ui,sans-serif;padding:10px 12px;border-radius:8px;' +
    'max-width:250px;-webkit-user-select:none;user-select:none;border:1px solid rgba(255,255,255,.25)');
  var eng = /applewebkit/i.test(navigator.userAgent) && !/chrome|crios|edg/i.test(navigator.userAgent)
            ? 'Safari / WebKit' : (/firefox/i.test(navigator.userAgent) ? 'Firefox' : 'Chrome / Blink');
  var head = document.createElement('div');
  head.innerHTML = '<b style="font-size:13px">FPS <span id="dFps">--</span></b>' +
    '<div style="opacity:.8">worst frame <span id="dWorst">--</span> ms</div>' +
    '<div style="opacity:.8">long frames (&gt;32ms) <span id="dLong">0</span></div>' +
    '<div style="opacity:.6;margin-top:4px;font-size:11px">' + eng +
    ' &middot; ' + Math.round(innerWidth) + '×' + Math.round(innerHeight) +
    ' @' + (window.devicePixelRatio || 1) + 'x</div>' +
    '<div style="opacity:.6;font-size:11px;margin-bottom:6px">tap a row to turn it off</div>';
  box.appendChild(head);

  Object.keys(RULES).forEach(function (key) {
    var row = document.createElement('div');
    row.textContent = '✓ ' + LABEL[key];
    row.setAttribute('style', 'cursor:pointer;padding:3px 0;border-top:1px solid rgba(255,255,255,.12)');
    var off = !!sheets[key];
    function paint() {
      row.textContent = (off ? '✗ ' : '✓ ') + LABEL[key];
      row.style.opacity = off ? '.45' : '1';
    }
    paint();
    row.addEventListener('click', function () { off = !off; setOff(key, off); paint(); reset(); });
    box.appendChild(row);
  });
  document.body.appendChild(box);

  var fpsEl = box.querySelector('#dFps'), worstEl = box.querySelector('#dWorst'), longEl = box.querySelector('#dLong');
  var note = document.createElement('div');
  note.setAttribute('style', 'margin-top:6px;font-size:11px;color:#ffd27f;display:none');
  note.textContent = 'Tab was in the background — numbers reset. Keep this window in front.';
  box.appendChild(note);

  var last = performance.now(), frames = 0, since = last, worst = 0, longs = 0;
  function reset() {
    worst = 0; longs = 0; frames = 0;
    last = performance.now(); since = last;
    longEl.textContent = '0'; worstEl.textContent = '--'; fpsEl.textContent = '--';
  }
  /* A hidden tab is throttled to ~1fps by the browser, which would look like a
     catastrophic stall. Ignore those frames entirely and say why. */
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { return; }
    note.style.display = 'block';
    reset();
  });
  function tick(now) {
    var dt = now - last; last = now;
    if (document.hidden) { requestAnimationFrame(tick); return; }
    frames++;
    if (dt > worst) { worst = dt; worstEl.textContent = Math.round(dt); }
    if (dt > 32) { longs++; longEl.textContent = longs; }
    if (now - since >= 1000) {
      fpsEl.textContent = Math.round(frames * 1000 / (now - since));
      frames = 0; since = now;
    }
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
}());
